import type { ICancellationToken } from '@cian/http-api';
import { type IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  createGetModerationComplainMicrofrontendModel,
  fetchGetModerationComplainMicrofrontend,
} from '@/repositories/manually-added/shared/moderation-complain-frontend/v1';
import { type IGetModerationComplainMicrofrontendResponse200 } from '@/repositories/manually-added/shared/moderation-complain-frontend/v1/types';

type FetchServiceParams = {
  applicationContext: IQueryStateAppContext;
  cancellationToken: ICancellationToken;
};

export function fetchGetModerationComplainMicrofrontendService(
  params: FetchServiceParams,
): Promise<IMicrofrontendManifest> {
  const {
    applicationContext: { httpApi, logger },
    cancellationToken,
  } = params;

  const fetchAssertsService = new FetchAssertsService(
    createGetModerationComplainMicrofrontendModel(),
    '@/shared/store/serverSide/moderation-complain-frontend/v1/get-moderation-complain-microfrontend/internal/fetchService.ts',
    logger,
  );

  return fetchGetModerationComplainMicrofrontend<IGetModerationComplainMicrofrontendResponse200>({
    config: { cancellationToken },
    httpApi,
  }).then(
    ({ statusCode, response }) => {
      switch (statusCode) {
        case 200:
          return response.manifest;
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
